// extracted by mini-css-extract-plugin
export default {"container":"about_container__l0nHe","overall":"about_overall__sdpOi","images":"about_images__OH+r4","imageBox":"about_imageBox__NBDFT","imageBoxx":"about_imageBoxx__umR5E"};